<div #expander [ngClass]="{'expander': true, 'expanded' :  expanderExpanded === true}">
  <div class="expander-content">
    <p *ngFor="let item of items; let i = index" class="text_{{getTextAlign(i)}}">{{item}}</p>
  </div>
</div>
